import * as types from './order-mutation-types';

export default {
  [types.APPLICANT_IDS_TO_CHANGE_SET](state, { applicantIds }) {
    state.applicantIdsToChange = applicantIds;
  },

  [types.ORDER_RECEIVE](state, { order }) {
    state.order = order;
  },

  [types.RESET_NEW_ORDER_DATA](state, { isUniversalIdentity }) {
    state.newOrder.applicant = [
      { applicant_name: '', identity_id: isUniversalIdentity ? 5 : undefined, msg: '' },
    ];
    state.newOrder.departDate = '';
    state.newOrder.expressList = [];
  },

  [types.CLREAR_NEW_ORDER_EXPRESS_LIST](state) {
    state.newOrder.expressList = [];
  },

  [types.ADD_NEW_ORDER_APPLICANT](state, { applicant }) {
    state.newOrder.applicant = [...state.newOrder.applicant, applicant];
  },

  [types.SELECT_NEW_ORDER_DEPART_DATE](state, { date }) {
    state.newOrder.departDate = date;
  },

  [types.DELETE_NEW_ORDER_APPLICANT](state, { index }) {
    state.newOrder.applicant.splice(index, 1);
  },

  [types.IMPORT_NEW_ORDER_APPLICANTS](state, { applicants }) {
    state.newOrder.applicant = applicants;
  },

  [types.CLEAR_NEW_ORDER_APPLICANT_MSG](state) {
    state.newOrder.applicant.forEach((ap) => {
      if (ap.msg) {
        delete ap.msg;
      }
    });
  },

  [types.CLEAR_NEW_FLIGGY_ORDER_APPLICANT_MSG](state) {
    state.newFliggyOrder.applicant_set.forEach((ap) => {
      if (ap.msg) {
        delete ap.msg;
      }
    });
  },

  [types.SET_APPLICANT_MSG](state, { index, msg }) {
    state.newOrder.applicant[index].msg = msg;
  },

  [types.UPDATE_APPLICANT_NAME](state, { index, value }) {
    state.newOrder.applicant[index].applicant_name = value;
  },

  [types.UPDATE_APPLICANT_IDENTITY](state, { index, identity }) {
    state.newOrder.applicant[index].identity_id = identity;
  },

  /* [types.UPDATE_OTA_ID](state, { otaId }) {
    state.newOtaOrder.ota_id = otaId;
  }, */

  [types.UPDATE_OTA_STORE_ID](state, { otaStoreId }) {
    state.newOtaOrder.ota_store_id = otaStoreId;
  },

  [types.UPDATE_OTA_ORDER_NUM](state, { otaOrderNo }) {
    state.newOtaOrder.ota_order_no = otaOrderNo;
  },

  [types.UPDATE_OTA_APPLICANT_COUNT](state, { applicantCount }) {
    state.newOtaOrder.applicant_count = applicantCount;
  },

  [types.RESET_OTA_ORDER](state) {
    state.newOtaOrder = {
      // ota_id: 1,
      ota_store_id: null,
      ota_order_no: '',
      applicant_count: null,
    };
  },

  [types.UPDATE_NEW_FLIGGY_ORDER_APPLICANT_FIELD](state, { field, value, index }) {
    state.newFliggyOrder.applicant_set[index][field] = value;
  },

  [types.ADD_NEW_FLIGGY_ORDER_APPLICANT](state, { applicant_set }) {
    state.newFliggyOrder.applicant_set = [...state.newFliggyOrder.applicant_set, applicant_set];
  },

  [types.DELETE_NEW_FLIGGY_ORDER_APPLICANT](state, { index }) {
    state.newFliggyOrder.applicant_set.splice(index, 1);
  },

  [types.SELECT_NEW_FLIGGY_ORDER_DEPART_DATE](state, { date }) {
    state.newFliggyOrder.departDate = date;
  },

  [types.SET_FLIGGY_APPLICANT_MSG](state, { index, msg }) {
    state.newFliggyOrder.applicant_set[index].msg.splice(0, state.newFliggyOrder.applicant_set[index].msg.length, ...msg);
  },

  [types.RESET_NEW_FLIGGY_ORDER_DATA](state, { isUniversalIdentity }) {
    state.newFliggyOrder = {
      ota_sub_order_id: null,
      departDate: '',
      offline: null,
      applicant_set: [{
        surname: '',
        given_name: '',
        surname_pinyin: '',
        given_name_pinyin: '',
        credential_no: '',
        identity_id: isUniversalIdentity ? 5 : undefined,
        msg: [],
      }],
    };
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/order/order-mutations.js